import { combineReducers } from 'redux';
import billingReducer from './billingReducer';
import invoiceReducer from './invoiceReducer';
import runMinuteReducer from './runMinuteReducer';
import planReducer from './planReducer';

const organizationsReducer = combineReducers({
  billing: billingReducer,
  invoices: invoiceReducer,
  usage: runMinuteReducer,
  plans: planReducer,
});

export default organizationsReducer;
